export const getVehicleKilometers = (value: number | undefined) => {
  return value !== null && value !== undefined ? formatKilometers(value) : '-';
};

export const formatKilometers = (value: number): string => {
  return `${value.toLocaleString()} km`;
};
